import { render, staticRenderFns } from "./ListUpdates.vue?vue&type=template&id=4028e569&"
import script from "./ListUpdates.vue?vue&type=script&lang=js&"
export * from "./ListUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports